import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import ReactLoading from "react-loading";
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";
import base64_arraybuffer from "base64-arraybuffer";

const BekKvkkModal = (props) => {
    const [show] = useState(props.show);
    const [loading, setLoading] = useState(true);
    const [accept, setAccept] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [url, setUrl] = useState(undefined);
    const [contract, setContract] = useState(undefined);

    useEffect(() => {
        request({
            'url': '/bek-kvkk/getBekKvkkContract',
            'method': 'get'
        }).then((response) => {
            if (response && response.data) {
                const data = response.data
                if (data.html) {
                    let contractArr = new Uint8Array(base64_arraybuffer.decode(data.html));
                    let blob = new Blob([contractArr], {type: "text/html"});
                    let urlCreator = window.URL || window.webkitURL;
                    setUrl(urlCreator.createObjectURL(blob));
                }

                setContract(data.value);
            }
            setLoading(false);
        }).catch((exception) => {
            setLoading(false);
            showAxiosError(exception);
        });
    }, []);

    const save = () => {
        request({
            'url': '/bek-kvkk/stampAndWriteBekKvkk',
            'method': 'post',
            'data': {value: contract}
        }).then((response) => {
            setLoading(false);
            props.close();
        }).catch((exception) => {
            setLoading(false);
            showAxiosError(exception);
        });
    }

    const renderModalBody = () => {
        return (
            <div className="col-sm-12 row mx-auto">
                <div className="col-sm-12 row mx-auto">
                    <div className="col-sm-12 row mx-auto">
                        {url && <iframe src={url} style={{width: "100%", height: "500px"}}/>}
                    </div>
                    <div className="col-sm-12 row mx-auto">
                        <div className="col-sm-1">
                            <input type="checkbox" name="accept"
                                   value={accept.toString()}
                                   checked={!!accept}
                                   onChange={(e) => setAccept(e.target.checked)}/>
                        </div>
                        <div className="col-sm-11" style={{maxWidth: "none"}}>
                            <label>Aydınlatma metnini okudum, anladım.</label>
                        </div>
                    </div>
                    <div className="col-sm-12 row mx-auto">
                        <div className="col-sm-1">
                            <input type="checkbox" name="accept"
                                   value={confirm.toString()}
                                   checked={!!confirm}
                                   onChange={(e) => setConfirm(e.target.checked)}/>

                        </div>
                        <div className="col-sm-11" style={{maxWidth: "none"}}>
                            <label>KVK aydınlatma metninde belirtilen verilerimin iş geliştirme ve müşteri ilişkilerinin
                                yürütülmesi amacıyla işbirliği içerisinde olunan
                                S.S. Bursa Eczacılar Üretim Temin ve Dağıtım Kooperatifi'ne aktarılmasına açık rıza
                                veriyorum.</label>
                        </div>
                    </div>
                </div>
            </div>

        )
    }

    const renderModalFooter = () => {
        return (
            <div className="col-sm-12 row mx-auto">
                <div className="col-sm-12 " style={{textAlign: 'right'}}>
                    <button type="button" data-toggle="tooltip" data-placement="bottom"
                            style={{
                                background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                padding: '10px 54px 10px 23px'
                            }}
                            disabled={!(confirm && accept)}
                            rel="tooltip" className='TekBtn kaydet btn-icon'
                            onClick={save}
                    >
                        Kaydet
                    </button>
                </div>
            </div>
        );
    }

    return (
        <section>
            <Modal show={show} onHide={() => props.close()} size="xl">
                <Modal.Header closeButton style={{padding: '22px 25px'}}>Bek Kvkk Onay Metni</Modal.Header>
                <Modal.Body>
                    {loading && <ReactLoading type="spinningBubbles" style={{
                        width: "100px",
                        height: "100px",
                        margin: "100px auto 100px auto",
                        fill: "#888"
                    }}/>}

                    {!loading && renderModalBody()}
                </Modal.Body>
                <Modal.Footer>
                    {!loading && renderModalFooter()}
                </Modal.Footer>
            </Modal>
        </section>
    )
}

export default BekKvkkModal;